import { render, staticRenderFns } from "./playersList.vue?vue&type=template&id=35669a56&scoped=true"
import script from "./playersList.vue?vue&type=script&lang=js"
export * from "./playersList.vue?vue&type=script&lang=js"
import style0 from "./playersList.vue?vue&type=style&index=0&id=35669a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35669a56",
  null
  
)

export default component.exports